module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "ql-admin"
    }
  }, [_c('md-toolbar', [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleLeftSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h2', [_vm._v("Cuelist Admin Dashboard")])], 1), _vm._v(" "), _c('core-nav-main', {
    attrs: {
      "project": _vm.project,
      "user": _vm.user
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "user-list"
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25",
      "md-flex-offset": "5"
    }
  }, [_c('h2', [_vm._v("List of User Stripe IDs")])]), _vm._v(" "), _c('md-layout', {
    staticClass: "header",
    attrs: {
      "md-gutter": "8",
      "md-row": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-offset": "5"
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("Name")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("Active Pay")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('span', {
    staticClass: "md-title"
  }, [_vm._v("Stripe ID")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.sortedUsers), function(usr) {
    return _c('md-layout', {
      key: usr.uid,
      attrs: {
        "md-gutter": "8",
        "md-row": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-column": "",
        "md-flex": "30",
        "md-flex-offset": "5"
      }
    }, [_c('strong', [_vm._v(_vm._s(usr.username))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(usr.email))])]), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "15",
        "md-align": "center"
      }
    }, [_c('md-checkbox', {
      model: {
        value: (usr.active_pay),
        callback: function($$v) {
          _vm.$set(usr, "active_pay", $$v)
        },
        expression: "usr.active_pay"
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "25"
      }
    }, [_c('md-input-container', [_c('md-input', {
      model: {
        value: (usr.stripe_id),
        callback: function($$v) {
          _vm.$set(usr, "stripe_id", $$v)
        },
        expression: "usr.stripe_id"
      }
    })], 1)], 1), _vm._v(" "), _c('md-button', {
      on: {
        "click": function($event) {
          _vm.updateUser(usr)
        }
      }
    }, [_vm._v("Update")])], 1)
  })], 2), _vm._v(" "), _c('core-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bbe970c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/views/admin-dashboard.vue
// module id = 649
// module chunks = 2